import type { Appearance } from '@stripe/stripe-js';

import { useTheme } from '@/ui/theme';

export const useStripeElementsAppearance = (): Appearance => {
  const { colors, fonts, keylines, text, forms } = useTheme();

  return {
    theme: 'stripe',
    variables: {
      // This doesn't accept 'transparent' as a value, hence backgroundColor selections in .Input, .Tab, and .Block
      colorBackground: forms.input?.backgroundColor,
      colorDanger: colors.error,
      fontFamily: fonts.body,
      fontSizeBase: String(text.bodyCopy.fontSize),
      colorText: forms.stripe?.text?.color,
      colorPrimary: forms.stripe?.text?.color ?? '#30313d',
      colorTextSecondary: forms.stripe?.text?.color,
      iconRedirectColor: forms.stripe?.text?.color,
      focusOutline: `1px solid ${colors.textSecondary}`,
      focusBoxShadow: 'none',
      colorTextPlaceholder: forms.input?.placeholder?.color ?? '#718096',
    },
    rules: {
      '.Input': {
        border: String(forms.input?.border ?? keylines?.border),
        padding: String(forms.input?.padding ?? '16px'),
        backgroundColor: String(forms.input?.backgroundColor ?? 'transparent'),
        color: forms.input?.color ?? 'inherent',
        fontSize: String(forms.input?.fontSize ?? 'inherent'),
        borderRadius: String(forms.input?.borderRadius ?? '4px'),
        lineHeight: '24px',
        fontWeight: String(forms.input?.fontWeight ?? 'inherent'),
      },
      '.Label': {
        marginBottom: '8px',
        color: forms.label?.color ?? '#3D3937',
        fontSize: String(forms.label?.fontSize ?? '16px'),
        lineHeight: String(forms.label?.lineHeight ?? '24px'),
      },
      '.Tab': {
        border: String(
          forms.stripe?.tab?.border ?? forms?.input?.border ?? keylines?.border
        ),
        backgroundColor: String(
          forms.stripe?.tab?.backgroundColor ?? 'transparent'
        ),
        marginBottom: '16px',
      },
      '.Block': {
        border: String(forms?.input?.border ?? keylines?.border),
        backgroundColor: String(
          forms.stripe?.tab?.backgroundColor ?? 'transparent'
        ),
      },
      '.Tab:focus,.Input:focus': {
        outlineOffset: '2px',
      },
    },
  };
};
